import React, {useState} from 'react';
import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    Link,
    OutlinedInput,
    Typography
} from '@mui/material';
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {useAppDispatch} from "../../app/hooks";
import {useTheme} from "@mui/material/styles";
import LoginContainer from "../../app/components/LoginContainer";
import {useSearchParams} from "react-router-dom";
import api from "../../app/axios";

function PasswordReset() {
    const dispatch = useAppDispatch();
    const [error, setError] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [showCurrentPassword, setShowCurrentPassword] = useState(false)
    const [showNewPassword, setShowNewPassword] = useState(false)
    const theme = useTheme();
    const [searchParams, setSearchParams] = useSearchParams();
    const [message, setMessage] = useState<string>();

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const newPassword = formData.get('newPassword') as string;
        const confirmPassword = formData.get('confirmPassword');

        if (newPassword === confirmPassword) {
            setError('');
                api.post(`oapi/password_reset_confirm/${searchParams.get('uid')}/${searchParams.get('token')}/`, {
                    new_password1: newPassword,
                    new_password2: confirmPassword
                }).then((response) => {
                    if (response.status === 200) {
                        setMessage('Senha alterada com sucesso.')
                    } else {
                        setMessage('Ocorreu um erro para alterar sua senha, o link pode ter expirado. Tente novamente.')
                    }
                })
        } else {
            setError('As senhas não correspondem');
        }
    };

    if (!message) {
        return (
            <LoginContainer>
                <Typography variant="h4" gutterBottom>
                    Definir nova senha
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{mt: 1}}>
                    <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Nova senha</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            name="newPassword"
                            type={showNewPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                        onMouseDown={(event) => event.preventDefault()}
                                        edge="end"
                                    >
                                        {showNewPassword ? <VisibilityOff/> : <Visibility/>}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Password"
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Confirmar nova senha</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            name="confirmPassword"
                            type={showConfirmPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        onMouseDown={(event) => event.preventDefault()}
                                        edge="end"
                                    >
                                        {showConfirmPassword ? <VisibilityOff/> : <Visibility/>}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Password"
                        />
                    </FormControl>
                    <Typography color="error">{error}</Typography>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color='primary'
                        sx={{mt: 3, mb: 2, fontWeight: 900, color: theme.palette.secondary.main}}
                    >
                        Alterar Senha
                    </Button>
                </Box>
            </LoginContainer>
        );
    } else {
        return (
            <LoginContainer>
                <Box sx={{mt: 1}}>
                    <Typography variant="body1" gutterBottom>
                        {message}
                    </Typography>
                    <Link color="primary" href="/">
                        <Button fullWidth variant="contained" color="primary" type="submit" sx={{mt: 3, mb: 2, fontWeight:900, color: theme.palette.secondary.main}}>
                            Voltar para a página inicial
                        </Button>
                    </Link>
                </Box>
            </LoginContainer>
        );
    }
}

export default PasswordReset;
